import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center text-xl font-bold">
                <i className="ri-fire-fill" />
              </span>
              <span className="font-logo text-2xl text-background-50">搞鸡</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">
              搞鸡是一个聚焦综艺娱乐新闻与趣味内容的资讯平台，提供及时、多元的综艺资讯、娱乐新闻与趣味视频推荐，
              让每一次打开都轻松愉快。
            </p>
            <div className="flex items-center gap-3 mt-6">
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-background-100 hover:bg-primary-500 hover:text-background-50 cursor-pointer transition-colors">
                <i className="ri-mail-line" />
              </span>
            </div>
          </div>

          {/* Channels */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">
              <Link to="/category/variety" className="hover:text-primary-300">内容频道</Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/category/variety" className="text-background-200 hover:text-primary-300 cursor-pointer">综艺资讯</Link></li>
              <li><Link to="/category/news" className="text-background-200 hover:text-primary-300 cursor-pointer">娱乐新闻</Link></li>
              <li><Link to="/category/videos" className="text-background-200 hover:text-primary-300 cursor-pointer">趣味视频</Link></li>
              <li><Link to="/search" className="text-background-200 hover:text-primary-300 cursor-pointer">全站搜索</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-background-50 text-sm font-semibold mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-background-200">
                <i className="ri-mail-line text-primary-300" /> contact@gaoji.example
              </li>
              <li className="flex items-center gap-2 text-background-200">
                <i className="ri-wechat-line text-primary-300" /> 微信公众号：搞鸡娱乐
              </li>
              <li className="flex items-center gap-2 text-background-200">
                <i className="ri-time-line text-primary-300" /> 周一至周五 10:00 - 19:00
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-300">
          <p>© {year} 搞鸡娱乐资讯网 · 本站内容均为示例数据，仅用于展示演示</p>
          <div className="flex items-center gap-5">
            <Link to="/about" className="hover:text-primary-300 cursor-pointer">关于我们</Link>
            <Link to="/about" className="hover:text-primary-300 cursor-pointer">使用说明</Link>
            <Link to="/about" className="hover:text-primary-300 cursor-pointer">版权声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}